import * as Api from '../api';

class TokenService {
    private _personalToken: string;

    private _personalTokenPromise: Promise<string> | null;

    constructor() {
        this._personalToken = '';
        this._personalTokenPromise = null;
    }

    async getPersonalToken(force = false) {
        if (!force && this._personalToken) {
            return this._personalToken;
        }

        if (!this._personalTokenPromise) {
            this._personalTokenPromise = Api.AI.getPersonalToken()
                .then((resp) => {
                    if (resp.successful) {
                        this._personalToken = resp.returnData?.token || '';
                    }
                    return this._personalToken;
                })
                .finally(() => {
                    this._personalTokenPromise = null;
                });
        }

        return this._personalTokenPromise;
    }
}

export default new TokenService();
